import script from "./ZTag.vue?vue&type=script&setup=true&lang=js"
export * from "./ZTag.vue?vue&type=script&setup=true&lang=js"

import "./ZTag.vue?vue&type=style&index=0&id=51c73ad5&lang=scss"

const __exports__ = script;

export default __exports__